import { ContactsApiProvider } from './contactsapi.services';

export const AcceptAutoAssignedLead = (acceptLeadDetails) => (dispatch, getState) => {
  return dispatch(ContactsApiProvider.put('/agentautoassignment/leadacceptance', acceptLeadDetails));
};

export const fetchAutoAssignedContact = (contactKey, embed = null) => {
  return ContactsApiProvider.get(`/agentautoassignment/contacts/${contactKey}?embed=${embed}`);
};

export const fetchAutoAssignedOpportunitiy = (contactKey, opportunityId) => {
  return ContactsApiProvider.get(`/agentautoassignment/contacts/${contactKey}/opportunities/${opportunityId}`);
};
